module.exports = __webpack_public_path__ + "img/miaosha_block_bg.2b6c024.png";